export function nameFromUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const cleanUrl = url.split('#')[0];
  const filename = cleanUrl.split('/').pop().split('?')[0];
  const dotIndex = filename.lastIndexOf('.');
  const withoutExtension = dotIndex !== -1 ? filename.slice(0, dotIndex) : filename;
  return withoutExtension.split('-').join(' ').split('_').join(' ').trim();
}

export function slugToTitle(slug) {
  if (!slug) return '';

  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
